import axios from "axios";
import { baseURL } from "../../../../utils/http/http-common";
import { apiEndPoints } from "../../../../utils/http";

export const CaseTransferProcess = async (data) => {
  try {
    const response = await axios.post(
      `${baseURL}${apiEndPoints.CaseTransfer_CaseTransferProcess}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSchoolByStudentDetails = async (
  userId,
  studentName,
  fatherName,
  DOB
) => {
  try {
    const response = await axios.get(
      `${baseURL}${apiEndPoints.CaseTransfer_GetSchoolByStudentDetails}/${userId}/${studentName}/${fatherName}`,
      {
        headers: {
          "Content-Type": "application/json",
          dob: DOB,
        },
      }
    );
    return response?.data?.response;
  } catch (error) {
    throw error;
  }
};

export const checkAssessedStudent = async (
  userId,
  studentName,
  fatherName,
  schoolId,
  DOB
) => {
  try {
    const response = await axios.get(
      `${baseURL}/CaseTransfer/${userId}/${studentName}/${fatherName}/${schoolId}/${apiEndPoints.CaseTransfer_CheckAssessedStudent}`,
      {
        headers: {
          "Content-Type": "application/json",
          dob: DOB,
        },
      }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const sendCaseTransferRequest = async (data) => {
  try {
    const response = await axios.post(
      `${baseURL}${apiEndPoints.CaseTransfer_SendCaseTransferRequest}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const studentCaseTransferHistory = async (studentId) => {
  try {
    const response = await axios.get(
      `${baseURL}/CaseTransfer/${studentId}/${apiEndPoints.CaseTransfer_StudentCaseTransferHistory}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAdvanceScreeningQnA = async (studentId, userId, languageId) => {
  try {
    const response = await axios.get(
      `${baseURL}/CaseTransfer/${studentId}/${userId}/${languageId}/${apiEndPoints.CaseTransfer_GetActiveQuestionAdvanceScreening}`
    );
    return response?.data?.response;
  } catch (error) {
    console.log("Error Getting Screeing 3 Questions : ", error);
    throw error;
  }
};

export const postAdvanceScreeningConcernData = async (data) => {
  try {
    const response = await axios.post(
      `${baseURL}${apiEndPoints.CaseTransfer_PostAdvanceScreeningConcerns}`,
      data
    );
    return response?.data?.response;
  } catch (error) {
    console.log("Error Posting Screeing 3 Data : ", error);
    throw error;
  }
};

export const isVisibleViewHistoryButton = async (studentId, userId) => {
  try {
    const response = await axios.get(
      `${baseURL}/CaseTransfer/${studentId}/${userId}/${apiEndPoints.CaseTransfer_ButtonBehaviour}`
    );
    return response?.data?.response;
  } catch (error) {
    throw error;
  }
};

export const reScreening = async (studentId, userId) => {
  try {
    const response = await axios.post(
      `${baseURL}/CaseTransfer/${studentId}/${userId}/${apiEndPoints.CaseTransfer_ReScreening}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getScreeningProfilerHistory = async (
  studentId,
  userId,
  languageId
) => {
  try {
    const response = await axios.get(
      `${baseURL}/CaseTransfer/${studentId}/${userId}/${languageId}/${apiEndPoints.CaseTransfer_ScreeningProfilerHistory}`
    );
    return response?.data?.response;
  } catch (error) {
    throw error;
  }
};

export const studentAgeCriteria = async (DOB, gradeid, languageid) => {
  try {
    const response = await axios.post(
      `${baseURL}${apiEndPoints.Validate_Student_Age_Criteria}`,
      {
        dob: DOB,
        gradeId: gradeid,
        languageId: languageid,
      },
      {
        headers: {
          Accept: "text/plain",
          "Content-Type": "application/json-patch+json",
        },
      }
    );

    return response;
  } catch (error) {
    throw error;
  }
};
